import React, { FC } from 'react';
import { Tabs } from '@components/UIKit/Tabs/Tabs';
import { ITabItem } from '@specs/types';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
interface Props {}
export const TabItems: FC<Props> = ({}) => {
  const router = useRouter();
  const tabs: ITabItem[] = [{
    text: 'feed.page.feed.tab.digital',
    icon: {
      name: 'digital'
    },
    href: LinksEnum.EXPLORE_TOYS,
    isActive: router.pathname === LinksEnum.EXPLORE_TOYS
  }, {
    text: 'feed.page.feed.tab.physical',
    icon: {
      name: 'physical'
    },
    href: LinksEnum.EXPLORE_TOYS_PHYSICAL,
    isActive: router.pathname === LinksEnum.EXPLORE_TOYS_PHYSICAL
  }];
  return <Tabs tabs={tabs} data-sentry-element="Tabs" data-sentry-component="TabItems" data-sentry-source-file="TabItems.tsx" />;
};